import React, { useEffect, useState } from "react";
import { I18nTranslator, translations } from "utils/i18n";
import { AppTable } from "components/molecules";
import { TableHelper } from "helpers";
import { GridColDef } from "@mui/x-data-grid";
import { usePaginationRequest } from "hooks/useRequest";
import { IGetAllLocationsReportRequest, ILocationReport } from "model";
import { ReportApiService } from "services";
import { isEmpty } from "lodash";

interface ILocationListProps {
  request: IGetAllLocationsReportRequest;
}

const LocationList = (props: ILocationListProps) => {
  const { request } = props;
  const [getAllLocationRequest, setGetAllLocationRequest] = useState({
    ...request,
    pageNumber: 1,
    pageSize: 100,
  });

  const { loading, result } = usePaginationRequest<
    IGetAllLocationsReportRequest,
    ILocationReport[]
  >(getAllLocationRequest, ReportApiService.getAllLocationsReport);
  useEffect(() => {
    setGetAllLocationRequest({ ...getAllLocationRequest, ...request });
  }, [request]);

  const handleChangePage = (pageNumber: number) => {
    setGetAllLocationRequest({
      ...getAllLocationRequest,
      pageNumber: pageNumber,
    });
  };

  const _handlePageSizeChange = (pageSize: number) => {
    setGetAllLocationRequest({
      ...getAllLocationRequest,
      pageSize: pageSize,
    });
  };

  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),
    TableHelper.createCell({
      field: "zoneName",
      headerName: I18nTranslator(translations.report.zoneName),
      size: "small",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "lineName",
      headerName: I18nTranslator(translations.report.lineName),
      size: "small",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "locationName",
      headerName: I18nTranslator(translations.report.locationName),
      size: "small",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "palletCode",
      headerName: I18nTranslator(translations.report.palletCode),
      size: "small",
    }),
    TableHelper.createCell({
      field: "palletStatus",
      headerName: I18nTranslator(translations.report.palletStatus),
      size: "small",
    }),
    TableHelper.createCell({
      field: "productLot",
      headerName: I18nTranslator(translations.report.productLot),
      size: "small",
    }),
    TableHelper.createCell({
      field: "productCode",
      headerName: I18nTranslator(translations.report.productCode),
      size: "small",
    }),
    TableHelper.createCell({
      field: "productName",
      headerName: I18nTranslator(translations.report.productName),
      size: "full",
    }),
    TableHelper.createCell({
      field: "productCodeOld",
      headerName: I18nTranslator(translations.report.productCodeOld),
      size: "small",
    }),
    TableHelper.createCell({
      field: "uom",
      headerName: I18nTranslator(translations.report.uom),
      size: "small",
    }),
    TableHelper.createCell({
      field: "packSize",
      headerName: I18nTranslator(translations.report.packSize),
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "cartonQuantity",
      headerName: I18nTranslator(translations.report.cartonQuantity),
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "quantity",
      headerName: I18nTranslator(translations.report.productQuantity),
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "manufacturingDate",
      headerName: I18nTranslator(translations.report.manufacturingDate),
      size: "small",
    }),
    TableHelper.createCell({
      field: "expiryDate",
      headerName: I18nTranslator(translations.report.expiryDate),
      size: "small",
    }),
    TableHelper.createCell({
      field: "strLocationPutDate",
      headerName: I18nTranslator(translations.report.locationPutDate),
      size: "small",
    }),
    TableHelper.createCell({
      field: "importDate",
      headerName: "Ngày nhập kho",
      size: "small",
    }),
    TableHelper.createCell({
      field: "agingStock",
      headerName: I18nTranslator(translations.report.agingStock),
      size: "small",
    }),

    TableHelper.createCell({
      field: "strDriverReceived",
      headerName: I18nTranslator(translations.report.forklift),
      size: "small",
    }),
  ];
  return (
    <AppTable<ILocationReport>
      loading={loading}
      data={result}
      columns={COLUMNS}
      actionColumnProps={{
        hideEdit: true,
      }}
      onSearch={(searchValue: string) => {}}
      searchPlaceholder={I18nTranslator(
        translations.placeholder.searchReceiveDocument
      )}
      onChangePage={handleChangePage}
      hideHeader
      hideSearch
      removeActionColumn
      defaultHeaderTable={280}
      onPageSizeChange={_handlePageSizeChange}
    />
  );
};

export default LocationList;
